import PolicyIcon from '@material-ui/icons/Policy';
import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const rootRouteRef = createRouteRef();
const page = PageBlueprint.make({
  params: {
    path: '/governanca/policy-gate',
    routeRef: rootRouteRef,
    loader: () =>
      import('./DeliveryPolicyGatePage').then(module => (
        <module.DeliveryPolicyGatePage />
      )),
  },
});

export const deliveryPolicyGatePlugin = createFrontendPlugin({
  pluginId: 'delivery-policy-gate',
  // Sem "(simulação)": o porteiro roda em enforce e já autorizou promoções
  // reais em produção. O modo vigente é mostrado na própria página, que o lê do
  // backend — um rótulo fixo aqui só teria como estar errado.
  title: 'Policy Gate',
  icon: <PolicyIcon />,
  routes: { root: rootRouteRef },
  extensions: [page],
});
